<template>
    <div>
        <div class="container-fluid-grid" v-if="$appUtils.isDesktop()">
            <div class="row">
                <div class="col-12">
                    <table v-if="$appUtils.isDesktop()" class="table table-hover table-striped table-sm">
                        <thead class="thead-dark thead-center">
                        <tr>
                            <th style="width: 50px">Tipo</th>
                            <th style="width: 60px">Pago</th>
                            <th style="width: 100px">Data</th>
                            <th>Identificador</th>
                            <th>Emissão</th>
                            <th>Pagamento</th>
                            <th>Agendamento</th>
                            <th style="width: 100px">Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="fm in results.financial_movements"
                            @click="showModal(fm)"
                            :key="fm.id">
                            <td class="ellipsis t-c v-m c-p tp" :class="fm.movement_type" :title="results.movement_types[fm.movement_type]">
                                <svg-icon :icon="fm.in ? 'arrow-circle-down' : 'arrow-circle-up'" :svg-class="fm.movement_type" :title="results.movement_types[fm.movement_type]"/>
                            </td>
                            <td class="ellipsis t-c v-m paid-status c-p">
                                <svg-icon :icon="fm.paid ? 'thumbs-up' : 'thumbs-down'"/>
                            </td>
                            <td class="ellipsis t-c c-p">{{fm.created_at | formatDate}}</td>
                            <td class="ellipsis c-p">{{fm.identifier}}</td>
                            <td class="ellipsis t-c c-p">{{fm.emitted_at | formatDate}}</td>
                            <td class="ellipsis t-c c-p">{{fm.paid_at | formatDate}}</td>
                            <td class="ellipsis t-c c-p ">{{fm.scheduled_to | formatDate}}</td>
                            <td class="ellipsis t-r f-w-700 c-p" >{{fm.value | formatMoney}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else class="grid-mobile"
             v-for="fm in results.financial_movements"
             @click="showModal(fm)"
             :key="fm.id">

            <span class="id">{{fm.identifier}}</span>
            <div class="tp">
                <svg-icon :icon="fm.in ? 'arrow-circle-down' : 'arrow-circle-up'" :svg-class="fm.movement_type" :title="results.movement_types[fm.movement_type]"/>
                <svg-icon :icon="fm.paid ? 'thumbs-up' : 'thumbs-down'"/>
            </div>

            <span class="created t-c">Quando<br>{{fm.created_at | formatDateHourMin}}</span>
            <span class="emit t-c">Emissão<br>{{fm.emitted_at | formatDate}}</span>
            <span class="paid t-c">Pag.<br>{{fm.paid_at | formatDate}}</span>
            <span class="sched t-c">Agend.<br>{{fm.scheduled_to | formatDate}}</span>

            <span class="vl">R$ {{fm.value | formatMoney}}</span>
        </div>

        <div ref="intersect" class="t-c refresh-container">
            <svg-icon icon="sync" svg-class="refresh load-more-crud" v-if="searching"/>
        </div>
    </div>
</template>

<script>
    import {EventBus} from "../../utils/EventBus";
    export default {
        name: "FinancialMovementsTab",
        props: {
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                results: {
                    movement_types: {},
                    financial_movements: [],
                },
                observerPagination: null,
                currentPage: 1,
                searching: false,
                isEnd: false
            }
        },
        methods: {
            loadMore() {
                if (this.entity.id && !this.searching && !this.isEnd){
                    this.searching = true;
                    this.$appHttp.get(`/v1/customers/load_financial_movements/${this.entity.id}?page=${this.currentPage++}`)
                        .then(({data}) => {
                            this.results.movement_types = data.movement_types;
                            this.results.financial_movements.push(...data.financial_movements);
                            this.isEnd = data.length === 0;
                        })
                        .catch(err => {
                            this.$appUtils.vibrate();
                            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema ao carregar os lançamentos financeiros.'}), this.$appStorage.getUser().name);
                            console.error(err);
                        })
                        .finally(() => this.searching = false)
                }
            },
            showModal(entity) {
                EventBus.showFinMov(() => {}, {entity: entity});
            }
        },
        mounted() {
            this.loadMore();

            this.observerPagination = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this.loadMore()
                })
            }, {
                root: null,
                rootMargin: '400px'
            });

            this.observerPagination.observe(this.$refs.intersect);
        },
        destroyed() {
            if (this.observerPagination) {
                this.observerPagination.disconnect();
                this.observerPagination = null;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/variables";
    td.tp, .grid-mobile .tp svg {
        &.income{color: $income_main_color}
        &.fixed_expenses{color: $fixed_expenses_main_color}
        &.taxes{color: $taxes_main_color}
        &.variable_expenses{color: $variable_expenses_main_color}
        &.people{color: $people_main_color}
    }
    .paid-status svg, td.tp svg {
        width: 1em;
        height: 1em;
    }
    .refresh-container {
        svg {
            width: 2em;
            height: 2em;
        }
    }

    .grid-mobile {
        display: grid;
        grid-template-columns: 2fr repeat(3, 1fr);
        grid-template-areas: 'id id id tp' 'created emit paid sched' 'vl vl vl vl';
        grid-template-rows: auto;
        grid-gap: 5px;
        padding: 5px;
        font-size: .8em;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .id {
            grid-area: id;
            font-weight: 700;
        }

        .tp {
            grid-area: tp;
            text-align: right;
            svg {
                &:not(:first-child) {
                    margin-left: 5px;
                }
                width: 1em;
                height: 1em;
            }
        }

        .created {grid-area: created;}
        .emit {grid-area: emit;}
        .paid {grid-area: paid;}
        .sched {grid-area: sched;}

        .vl {
            grid-area: vl;
            text-align: right;
            color: $theme_color_one;
            font-size: 1.3em;
        }

    }
</style>
